import type { Vehicle } from '../../types';

const isPHEV = (vehicle: Vehicle) => {
  return 'PHEV' === vehicle.fuelType.toUpperCase();
};

export default isPHEV;
